<template>
	<div>
		<div class="mb-5" v-if="edit">
			{{ item.id }}
			<o-field label="Title">
				<o-input v-model="item.title"></o-input>
			</o-field>
			<o-field label="Description">
				<o-input v-model="item.description" type="textarea"></o-input>
			</o-field>
			<o-field label="URL" message="Internal name, mailto: or https://<URL>">
				<o-input v-model="item.href" placeholder="https://www.google.com"></o-input>
			</o-field>
			<o-field label="Link text">
				<o-input v-model="item.text" placeholder="Read more"></o-input>
			</o-field>
			<o-field label="Open in a new tab">
				<o-switch v-model="item.target" :falseValue="'_self'" :trueValue="'_blank'"></o-switch>
			</o-field>
			<o-button class="mr-2" variant="primary" @click="Save">Save</o-button>
			<o-button @click="Cancel">Cancel</o-button>
		</div>
		<quick-link
			v-for="(link, i) in modelValue"
			:key="i"
			:link="link"
			:edit="edit"
			@edit="Edit(link, i)"
			@remove="Remove(i)"></quick-link>
	</div>
</template>
<script>
	import { ref } from "vue";
	import quickLink from "@/components/webComponents/quickLinks/quickLink.vue";

	export default {
		components: {
			quickLink
		},
		props: {
			modelValue: {
				type: Array,
				default: () => {
					return [];
				}
			},
			edit: {
				type: Boolean,
				default: false
			}
		},
		emtis: ["update:modelValue"],
		setup(props, context) {
			const item = ref({});

			const Save = () => {
				if (item.value.id >= 0) {
					const copy = props.modelValue;
					let link = copy.find((x) => x.id == item.value.id);
					link = item.value;
					context.emit("update:modelValue", copy);
					item.value = {};
				} else {
					context.emit("update:modelValue", props.modelValue.concat([{ ...item.value }]));
				}
			};

			const Cancel = () => {
				item.value = {};
			};

			const Remove = (index) => {
				const copy = props.modelValue.slice();
				copy.splice(index, 1);
				context.emit("update:modelValue", copy);
			};

			const Edit = (link, i) => {
				item.value = link;
				item.value.id = i;
			};

			return {
				item,
				Save,
				Cancel,
				Edit,
				Remove
			};
		}
	};
</script>
